import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import IMS from "./modules/ims";

import router from "../router";

import authServices from "@/Api/AuthService";

import { USE_OTP } from "@/config";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
    autenticado: false,
    remote_url: "http://186.32.6.132/rest",
    token: "",
    otpHash: "",

    user: { id: -1 },

    status: "",
    logged: false,

    error: null,
    loading: false,
    networkError: false,
  },
  getters: {
    getAutenticado(state) {
      return state.autenticado
    },
    getRemoteUrl(state) {
      return state.remote_url
    },
    getError: (state) => state.error,

    getToken: (state) => state.token,
    getOtpHash: (state) => state.otpHash,

    getUser: (state) => state.user,
    getLogged: (state) => state.logged,

    getHasPermission: (state) => state.hasPermission,

  },
  mutations: {
    CAMBIAR_LOADING(state, payload) {
      state.loading = payload;
    },
    CAMBIAR_ERROR(state, payload) {
      state.error = payload;
    },
    CAMBIAR_TOKEN(state, payload) {
      state.token = payload;
    },
    CAMBIAR_OTP_HASH(state, payload) {
      state.otpHash = payload;
    },
    CAMBIAR_NETWORK_ERROR(state, payload) {
      state.networkError = payload;
    },
    CAMBIAR_LOGGED(state, payload) {
      state.logged = payload;
    },
    CAMBIAR_AUTENTICADO(state, payload) {
      state.autenticado = payload;
    },
    CAMBIAR_USER(state, payload) {
      state.user = payload;
    },
  },

  actions : {
    doLogin({ commit }, params) {
      return Promise.resolve(params)
        .then((params) => {
          return authServices.doLogin(params);
        })
        .then(({ data }) => {
          if (data.status === 200) {
            commit("CAMBIAR_LOGGED", true);
            commit("CAMBIAR_USER", data.data);
            commit("CAMBIAR_TOKEN", data.token);
            commit("CAMBIAR_OTP_HASH", data.otpHash);

            if (!USE_OTP) {
              commit("CAMBIAR_ERROR", "");
              router.push("/main");
            }
          } else {
            commit("CAMBIAR_ERROR", data.mensaje);
          }
        })
        .catch((err) => {
          console.log("Login Error:", err);
          commit("CAMBIAR_ERROR", "ERROR DE RED");
        });
    },

    doCambiarClave({ commit }, params) {
      Promise.resolve(params)
        .then((params) => {
          return authServices.doCambiarClave(params);
        })
        .then(({ data }) => {
          if (data.status === 200) {
            commit("CAMBIAR_ERROR", "Contraseña actualizada");
            setTimeout(() => router.push("/main"), 3000);
          } else {
            commit("CAMBIAR_ERROR", data.mensaje);
          }
        })
        .catch((err) => {
          console.log("Login Error:", err);
          commit("CAMBIAR_ERROR", "ERROR DE RED");
        });
    },

    doLogout({ commit }, params) {
      Promise.resolve(params)
        .then((params) => {
          return authServices.doLogout(params);
        })
        .then(() => {
          commit("CAMBIAR_USER", null);
          commit("CAMBIAR_LOGGED", false);
          commit("CAMBIAR_AUTENTICADO", false);

          router.push("/");
        })
        .catch((err) => {
          console.log("Login Error:", err);
          commit("CAMBIAR_ERROR", "ERROR DE RED");
        });
    },

    doOtp({ commit }, params) {
      commit("CAMBIAR_ERROR", null);
      commit("CAMBIAR_LOADING", true);
      commit("CAMBIAR_AUTENTICADO", true);

      console.log(params);
      router.push("/main");
    },

    doRegistrarse({ commit }, params) {
      console.log("doRegistrar:", params);

      if (params.nombre && params.username && params.email) {
        Promise.resolve(params)
          .then((params) => {
            return authServices.doRegistrarse(params);
          })
          .then((data) => {
            if (data.status === 200) {
              commit("CAMBIAR_LOADING", true);
              commit("CAMBIAR_ERROR", null);

              router.push("/main");
            } else {
              commit("CAMBIAR_ERROR", data.mensaje);
            }
          })
          .catch((err) => {
            console.log("Login Error:", err);
            commit("CAMBIAR_ERROR", "ERROR DE RED");
          });
      } else {
        commit("CAMBIAR_ERROR", "Favor completar la información");
      }
    },

    doOlvidoClave({ commit }, params) {
      console.log("doOlvidoClave:", params);

      if (params.username) {
        Promise.resolve(params)
          .then((params) => {
            return authServices.doOlvidoClave(params);
          })
          .then((data) => {
            if (data.status === 200) {
              commit("CAMBIAR_LOADING", true);
              commit("CAMBIAR_ERROR", null);

              router.push("/");
            } else {
              commit("CAMBIAR_ERROR", data.mensaje);
            }
          })
          .catch((err) => {
            console.log("Login Error:", err);
            commit("CAMBIAR_ERROR", "ERROR DE RED");
          });
      } else {
        commit("CAMBIAR_ERROR", "Favor llenar la información");
      }
    },

    doRecuperarClave({ commit }, params) {
      console.log("doRecuperarClave:", params);

      if (params.username) {
        Promise.resolve(params)
          .then((params) => {
            return authServices.doOlvidoClave(params);
          })
          .then((data) => {
            if (data.status === 200) {
              commit("CAMBIAR_LOADING", true);
              commit("CAMBIAR_ERROR", null);

              router.push("/");
            } else {
              commit("CAMBIAR_ERROR", data.mensaje);
            }
          })
          .catch((err) => {
            console.log("Login Error:", err);
            commit("CAMBIAR_ERROR", "ERROR DE RED");
          });
      } else {
        commit("CAMBIAR_ERROR", "Favor llenar la información");
      }
    },

    doCargarMenu({ commit }, params) {

      return Promise.resolve(params)
        .then((params) => {
          return authServices.doCargarMenu(params);
        })
        .then((data) => {
          console.log("Auth.doCargarMenu - data:", data);
          if (data.status === 200) {
            commit("CAMBIAR_LOADING", true);
            commit("CAMBIAR_ERROR", null);
          } else {
            commit("CAMBIAR_ERROR", data.mensaje);
          }

          return data
        })
        .catch((err) => {
          console.log("Auth.doCargarMenu - err:", err);
          console.log("doCargarMenu Error:", err);
          commit("CAMBIAR_ERROR", "ERROR DE RED");
        });
    },

  },
  modules: {
    strict: debug,
    plugins: debug ? [createLogger()] : [], // set logger only for development
    IMS
  }
});
